import * as React from 'react';
import { useRecoilState } from 'recoil';
import { useIntl } from 'react-intl';
import { GRAPH_LIMIT } from './GraphService';
import { lastGraphReloadTimestampAtom } from './GraphState';

interface IProps {
  loadData: () => void;
  isActive: null | Date;
  selectedDate: Date[];
  pointsCount: number;
  isCompressed: boolean;
  isDetail: boolean;
}

export default function RideJustStarted(props: IProps) {
  const { formatMessage: f } = useIntl();

  const [lastGraphReloadTimestamp, setLastGraphReloadTimestamp] = useRecoilState<Date | null>(
    lastGraphReloadTimestampAtom
  );
  const [isDisabled, setIsDisabled] = React.useState(true);

  React.useEffect(() => {
    if (
      !props.isActive ||
      (lastGraphReloadTimestamp &&
        new Date(lastGraphReloadTimestamp.getTime() + 60000) > new Date())
    ) {
      setIsDisabled(true);
    } else {
      setIsDisabled(false);
    }
  }, [lastGraphReloadTimestamp, props.isActive]);

  const handleReload = () => {
    setLastGraphReloadTimestamp(new Date());
    props.loadData();
  };

  return props.selectedDate &&
    props.selectedDate[0] <= new Date() &&
    (props.isCompressed || props.pointsCount > GRAPH_LIMIT) ? (
    <div>
      {isDisabled ? (
        <span
          style={{
            position: 'absolute',
            top: props.isDetail ? '-40px' : '14px',
            right: props.isDetail ? '12px' : '77px',
          }}
        >
          <i
            className="cmd-icons cmd-icon-refresh mr-2 fs-4 text-gray-light"
            title={f({ id: 'graph.reloadDisabled.button.tooltip' })}
          />
        </span>
      ) : (
        <a
          data-cy="graph-reload"
          style={{
            position: 'absolute',
            top: props.isDetail ? '-45px' : '9px',
            right: props.isDetail ? '0' : '65px',
          }}
          title={f({ id: 'graph.reload.button.tooltip' })}
          href="#"
          className="px-3 py-2 d-flex align-items-center text-decoration-none text-gray"
          onClick={handleReload}
        >
          <i className="cmd-icons cmd-icon-refresh mr-2 fs-4" />
          <span className="sr-only">{f({ id: 'graph.reload.button.tooltip' })}</span>
        </a>
      )}
    </div>
  ) : null;
}
